const cfgData = require("./cfg.json");
// import {baseURL,params} from './cfg.json';
export const baseURL = 'http://192.168.1.54:8080';
export const baseURLCourse = 'http://192.168.1.54:9430/evcourse';
export const wqId = 'teepcloud';
export const params = cfgData.params;
export const head_items = cfgData.head_items;
// 路由白名单
export const whiteList = [
    '/page/index',
    '/page/course',
    '/page/info',
    '/page/teacher',
    '/page/teacher_details',
    '/page/info_details',
    '/page/login',
    '/page/course_details',
    '/page/company_brief',
    '/page/call_us',
    '/page/download',
    '/page/agreement',
    '/page/privacy_policy',
    '/page/studentWish'
]